var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{ref:"search",staticClass:"search-box",attrs:{"value":_vm.keyword,"append-icon":"search","placeholder":"検索","background-color":"white","solo":""},on:{"input":_vm.inputKeyword}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }